import React from 'react';
import Green404 from './layouts/green-404';

export default function NotFound404 () {
  return <Green404 />;
}
